import { Facebook, Github, Instagram, Linkedin, Twitter } from "lucide-react"
const Footer = () => {
  const currentYear = new Date().getFullYear()

  const socialLinks = [
    {
      name: "GitHub",
      url: "https://github.com/Kush-Varshney",
      icon: <Github className="w-5 h-5" />,
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/kush-varshney-490baa250",
      icon: <Linkedin className="w-5 h-5" />,
    },
    {
      name: "Twitter",
      url: "https://x.com/KushVar29010660",
      icon: <Twitter className="w-5 h-5" />,
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/kush_varshney_",
      icon: <Instagram className="w-5 h-5" />,
    },
    {
      name: "Facebook",
      url: "https://www.Facebook.com/kush.varshney.338",
      icon: <Facebook className="w-5 h-5" />,
    },
  ]

  return (
    <footer className="bg-gray-800 border-t border-gray-700">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-gray-300 text-sm">© {currentYear} Kush Varshney. All rights reserved.</p>
          </div>

          <div className="flex space-x-6">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200"
                aria-label={link.name}
              >
                {link.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
